import React from 'react';
import classNames from 'classnames';

// Reusable heading component for section titles
const Title = ({ children, className = '' }) => (
  <h2 className={classNames('text-2xl md:text-5xl text-center md:text-left font-extrabold text-[#003424]', className)}>
    {children}
  </h2>
);

export default Title;
